export const mutations = {
  setCentre(state, payload) {
    state.map.centre = payload.centre
  },
  setZoom(state, payload) {
    state.map.zoom = payload.zoom
  },
}
